import { Component } from '@angular/core';
import { GenericCrudComponent } from '../../../../shared/components/generic-crud/generic-crud.component';
import { GenericCRUD } from '../../../../models/GenericCRUD/GenericCRUD';
import { GenericTable, GenericTableAction, GenericTableColumn } from '../../../../models/GenericCRUD/GenericTable';
import { GenericForm, GenericFormField } from '../../../../models/GenericCRUD/GenericForm';
import { Filter } from '../../../../models/GenericCRUD/Filter';
import { Product } from '../../../../models/Product';
import { BreadcrumbService } from '../../../../core/services/breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-product-home',
  standalone: true,
  imports: [GenericCrudComponent],
  templateUrl: './product-home.component.html',
  styleUrl: './product-home.component.css'
})
export class ProductHomeComponent {

  constructor(
    private breadcrumbService: BreadcrumbService
  ) {
    // this.breadcrumbService.setBreadcrumb({
    //   display_name: 'Productos',
    //   url: '/dashboard/productos',
    //   items: []
    // });
  }
  tableColumns: GenericTableColumn[] = [
    { name: 'Nombre', active: true, type: 'text-title', key: 'name', sort: true },
    { name: 'Plantilla de Contrato', active: true, type: 'text', key: 'template.name', sort: false },
    { name: 'Sucursales', active: true, type: 'array', key: 'office_names', sort: false },
    { name: 'Precio Total', active: true, type: 'text', key: 'total_price', sort: false },
  ];


  formFields: GenericFormField[] = [
    { name: 'name', type: 'text', label: 'Nombre del Producto', validations: 'required' },
    { name: 'description', type: 'textarea', label: 'Descripción', colspan: 2 },
    { name: 'offices', type: 'select', label: 'Sucursales', validations: 'nullable', url: '/config/office/listAll', singleSelection: false, labelKey: 'name' },
    { name: 'company_id', type: 'select', label: 'Sociedad', validations: 'nullable', singleSelection: true, labelKey: 'name', fieldListener: 'offices', subfieldListener: 'companies' },
    { name: 'template_id', type: 'select', label: 'Plantilla', validations: 'nullable', url: '/template/listAll', singleSelection: true, labelKey: 'name' },
  ];

  formFieldsEdit: GenericFormField[] = [
    { name: 'name', type: 'text', label: 'Nombre del Producto', validations: 'required' },
    { name: 'description', type: 'textarea', label: 'Descripción', colspan: 2 },
    { name: 'offices', type: 'select', label: 'Sucursales', validations: 'nullable', url: '/config/office/listAll', singleSelection: false, labelKey: 'name' },
    { name: 'company_id', type: 'select', label: 'Sociedad', validations: 'nullable', singleSelection: true, labelKey: 'name', fieldListener: 'offices', subfieldListener: 'companies' },
    { name: 'template_id', type: 'select', label: 'Plantilla', validations: 'nullable', url: '/template/listAll', singleSelection: true, labelKey: 'name' },
  ];

  form: GenericForm = {
    formTitle: 'Crear Producto',
    successTitle: 'Creación correcta',
    errorTitle: 'Error en la creación',
    method: 'POST',
    fields: this.formFields,
    name: 'producto',
    createButtonTitle: 'Nuevo Producto',
    cols: 2,
    createApiSlug: '/product/store',
    formButtonTitle: 'Crear Producto',
    width: '4xl'
  };

  tableActions: GenericTableAction[] = [
    {
      name: 'Sacar a la venta',
      key: 'publish',
      method: 'POST',
      actionSlug: '/product/publish/{{id}}',
      confirmation: true,
      questionText: '¿Sacar este producto a la venta?',
      confirmText: 'Sí, sacar a la venta',
      showIf: (item: any) => !item.active,
      icon: `<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-green-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12l5 5l10 -10"/></svg>`,
    },
    {
      name: 'Retirar de la venta',
      key: 'unpublish',
      method: 'POST',
      actionSlug: '/product/unpublish/{{id}}',
      confirmation: true,
      questionText: '¿Retirar este producto de la venta? Volverá a borrador.',
      confirmText: 'Sí, retirar',
      showIf: (item: any) => item.active,
      icon: `<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-dark" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6l-12 12"/><path d="M6 6l12 12"/></svg>`,
    },
    {
      name: 'Editar',
      key: 'edit',
      form: {
        method: 'PUT',
        successTitle: 'Producto actualizado correctamente',
        errorTitle: 'Error al actualizar el producto',
        fields: this.formFieldsEdit,
        name: 'producto',
        createButtonTitle: '',
        cols: 2,
        createApiSlug: '',
        originalUpdateApiSlug: '/product/update/{{id}}',
        updateApiSlug: '',
        originalFormTitle: 'Editar producto',
        formTitle: '',
        formButtonTitle: 'Actualizar',
        width: '3xl'
      },
      completeForm: true,
      replaceAllRowOnResponse: true,
      icon: `<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-dark" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 7h-1a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2-2v-1"/><path d="M20.385 6.585a2.1 2.1 0 0 0-2.97-2.97l-8.415 8.385v3h3l8.385-8.415z"/><path d="M16 5l3 3"/></svg>`,
      confirmation: false
    },
    {
      name: 'Eliminar',
      key: 'delete',
      method: 'DELETE',
      icon: `<svg xmlns="http://www.w3.org/2000/svg" class="w-4 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-12"/><path d="M9 7V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v3"/></svg>`,
      confirmation: true,
      questionText: '¿Desea eliminar el producto?',
      deleteRowOnResponse: true,
      actionSlug: '/product/delete/{{id}}',
    },
  ];

  filters: Filter[] = [
    { type: 'search', key: 'name', operator: 'like', placeholder: 'Nombre del producto' },
  ];

  table: GenericTable<Product> = {
    columns: this.tableColumns,
    items: [],
    type: 'product',
    loadItemsSlug: '/product/index',
    paginate: true,
    name: 'productos',
    actions: this.tableActions,
    details: true,
    exportable: true,
  };

  genericCRUD: GenericCRUD<any> = {
    genericTable: this.table,
    genericForm: this.form,
    genericFilters: this.filters,
    useModalForm: false
  };

}
